module.exports = __webpack_public_path__ + "media/images/shark/BlueOcean_2-p-1080-9257e7d4c684295e248cf443ae27a968.jpeg";